__turbopack_context__.v({
  "background": "Overlay-module__Jwq8EW__background",
  "overlay": "Overlay-module__Jwq8EW__overlay",
  "overlayCentered": "Overlay-module__Jwq8EW__overlayCentered",
});
